export default {
    state: {
        sidebarType: "bg-default",
        darkMode: true,
        isNavFixed: false,
        isAbsolute: false,
        layout: "default",
        showPreloader: false
    },
    mutations: {
        setSidebarTypeMutation(state, values) {
            state.sidebarType = values
        },
        setDarkModeMutation(state, values) {
            state.darkMode = values
        },
        setIsNavFixedMutation(state) {
            state.isNavFixed = !state.isNavFixed;
        },
        setIsAbsoluteMutation(state, values) {
            state.isAbsolute = values
        },
        setLayoutMutation(state, values) {
            state.layout = values
        },
        setShowPreloader(state, value) {
            state.showPreloader = value
        },
        navbarMinimize(state) {
            const sidenav_show = document.querySelector(".g-sidenav-show");
            if (sidenav_show.classList.contains("g-sidenav-hidden")) {
                state.showSidenav = true;

                if (state.darkMode)
                    state.sidebarType = 'bg-default'

                sidenav_show.classList.remove("g-sidenav-hidden");
                sidenav_show.classList.add("g-sidenav-pinned");
                state.isPinned = true;
            } else {
                sidenav_show.classList.add("g-sidenav-hidden");
                state.showSidenav = false;
                sidenav_show.classList.remove("g-sidenav-pinned");
                state.isPinned = false;
            }
        },
    },
    getters: {
        getIsPinned(state) {
            return state.isPinned;
        },
        getSidebarType(state) {
            return state.sidebarType;
        },
        getDarkMode(state) {
            return state.darkMode;
        },
        getIsNavFixed(state) {
            return state.isNavFixed;
        },
        getIsAbsolute(state) {
            return state.isAbsolute;
        },
        getLayout(state) {
            return state.isLogined;
        },
        getShowPreloader(state) {
            return state.showPreloader;
        }
    },
}